import { Config } from '@/types';
import { WidgetStoreSliceCreator } from '../types';
import React from 'react';
import { ContextEngine } from '@/types';
import { CustomContext } from '@/types';

type StringOrContextFunction =
  | string
  | ((
      pageContext: ContextEngine.ContextResult | null,
      customContext: CustomContext | null
    ) => string);

export interface ConfigStore {
  readonly config: Config.Widget;
  setCustomComponent: (componentName: string, component: React.FC) => void;
  setWelcomeMessage: (welcomeMessage: StringOrContextFunction) => void;
}

export const createConfigSlice: WidgetStoreSliceCreator<ConfigStore> = set => ({
  // @ts-expect-error - config is initialized on hooks\stores\use-widget-store.ts
  config: null,
  setCustomComponent: (componentName: string, component: React.FC) =>
    set(state => ({
      config: {
        ...state.config,
        customComponents: {
          ...state.config.customComponents,
          [componentName]: component,
        },
      },
    })),
  setWelcomeMessage: (welcomeMessage: StringOrContextFunction) =>
    set(state => ({
      config: {
        ...state.config,
        features: {
          ...state.config.features,
          chat: {
            ...state.config.features?.chat,
            welcomeMessage,
          },
        },
      },
    })),
});
